/* eslint-disable no-unused-vars */
import { useInfiniteQuery } from 'react-query'

import { getViewPollParticipants } from 'services/endpoints/post'

export const useGetViewPollParticipants = (
    pollId: string,
    answerId: string
) => {
    return useInfiniteQuery(
        ['viewerPollParticipants', pollId, answerId],
        async ({ pageParam = 1 }) =>
            await getViewPollParticipants(pollId, answerId, pageParam),
        {
            getNextPageParam: lastPage => {
                if (
                    lastPage?.data?.pagination?.current_page *
                        lastPage?.data?.pagination?.per_page <
                    lastPage?.data?.pagination?.total
                ) {
                    return lastPage.data.pagination.current_page + 1
                }

                return undefined
            },
            enabled: Boolean(pollId && answerId),
            refetchOnWindowFocus: false,
            staleTime: 10000
        }
    )
}